"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isControl = exports.ControlStatusChoices = void 0;
var ControlStatusChoices = (function () {
    function ControlStatusChoices() {
    }
    ControlStatusChoices.toList = function () {
        return [this.POSSIBLE, this.PLANNED, this.ONGOING, this.DONE, this.DISCARDED];
    };
    ControlStatusChoices.toStringList = function () {
        return this.toList().map(function (s) { return s.toString(); });
    };
    ControlStatusChoices.asChoices = function () {
        return [
            { display_name: gettext("Possible"), value: this.POSSIBLE.toString() },
            { display_name: gettext("Planned"), value: this.PLANNED.toString() },
            { display_name: gettext("Ongoing"), value: this.ONGOING.toString() },
            { display_name: gettext("Done"), value: this.DONE.toString() },
            { display_name: gettext("Discarded"), value: this.DISCARDED.toString() },
        ];
    };
    ControlStatusChoices.POSSIBLE = 10;
    ControlStatusChoices.PLANNED = 20;
    ControlStatusChoices.ONGOING = 30;
    ControlStatusChoices.DONE = 40;
    ControlStatusChoices.DISCARDED = 50;
    ControlStatusChoices.INCOMPLETE = [10, 20, 30];
    ControlStatusChoices.COMPLETE = [40, 50];
    return ControlStatusChoices;
}());
exports.ControlStatusChoices = ControlStatusChoices;
function isControl(input) {
    return input.control_number !== undefined;
}
exports.isControl = isControl;
